import { string2Array } from '@/utils';
import { HealthCheckData } from '../../health-check';
import { Probe } from '../../types';

/**
 * 将健康检查数据转换为 yaml 数据
 */
export function probeToYaml(item: HealthCheckData): Probe {
  if (!item) return undefined;
  const tab = item.tab;
  const common = {
    initialDelaySeconds: item.initialDelay,
    timeoutSeconds: item.timeout,
    periodSeconds: item.checkPeriod,
    successThreshold: item.successThreshold,
    failureThreshold: item.failureThreshold,
  };

  switch (tab) {
    case 'TCP_PORT': {
      return {
        tcpSocket: {
          port: item.tcpPort,
        },
        ...common,
      };
    }
    case 'COMMAND': {
      return {
        exec: {
          command: string2Array(item.command),
        },
        ...common,
      };
    }
    case 'HTTP':
      return {
        httpGet: {
          scheme: item.protocol,
          path: item.path,
          port: item.httpPort,
        },
        ...common,
      };
    default:
      return undefined;
  }
}

/**
 * 将 yaml 数据转换为健康检查数据
 */
export function yamlToProbe(item: Probe): HealthCheckData {
  if (!item) return undefined;
  const common = {
    initialDelay: item.initialDelaySeconds,
    timeout: item.timeoutSeconds,
    checkPeriod: item.periodSeconds,
    successThreshold: item.successThreshold,
    failureThreshold: item.failureThreshold,
  };

  if ('tcpSocket' in item && item.tcpSocket) {
    return {
      tab: 'TCP_PORT',
      ...common,
      tcpPort: item.tcpSocket?.port,
    };
  }
  if ((item as any).exec) {
    return {
      tab: 'COMMAND',
      ...common,
      command: (item as any).exec?.command?.join(' '),
    };
  }
  if ('httpGet' in item && item.httpGet) {
    return {
      tab: 'HTTP',
      ...common,
      protocol: (item as any).httpGet?.scheme,
      path: (item as any).httpGet?.path,
      httpPort: (item as any).httpGet?.port,
    };
  }

  return undefined;
}
